import { render, staticRenderFns } from "./EdlPage.vue?vue&type=template&id=7ddb054f&scoped=true&"
import script from "./EdlPage.vue?vue&type=script&lang=js&"
export * from "./EdlPage.vue?vue&type=script&lang=js&"
import style0 from "./EdlPage.vue?vue&type=style&index=0&id=7ddb054f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb054f",
  null
  
)

export default component.exports